import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { useAtomCallbackMemoized } from '../../hooks/useAtomCallbackMemoized';
import { useTrackEvent } from '../../segment/segment';
import { EventTypeEnum } from '../../segment/types';
import { appointmentInfoAtom } from '../../state';
import { roomAtom } from '../../video-sdk';

export function useTrackSessionTopicsViewed(hasContent: boolean) {
  const { patientShortId = '' } = useParams();
  const { userViewed } = useTrackEvent();
  const getInSession = useAtomCallbackMemoized((get) => !!get(roomAtom), []);
  const getAppointmentShortId = useAtomCallbackMemoized((get) => get(appointmentInfoAtom)?.shortId ?? '', []);
  const hasTrackedView = useRef(false);

  useEffect(
    function trackSessionTopicsViewed() {
      if (hasTrackedView.current || !hasContent) return;
      userViewed(EventTypeEnum.SESSION_TOPICS_VIEWED, {
        patientShortId,
        inSession: getInSession(),
        appointmentShortId: getAppointmentShortId(),
      });
      hasTrackedView.current = true;
    },
    [getAppointmentShortId, getInSession, hasContent, patientShortId, userViewed],
  );
}
